import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/pic/enkrypt.png'


const _withScopeId = n => (_pushScopeId("data-v-45c9a4d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "claim-enkrypt-banner" }
const _hoisted_2 = { class: "claim-enkrypt-banner__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Create one in Enkrypt chrome extension", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Enkrypt is a wallet extension that allows you to use all networks. Most popular ones, like Ethereum and Polkadot with its Parachains are already built in. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "claim-enkrypt-banner__image",
  src: _imports_0,
  alt: ""
}, null, -1))

import BaseButton from "@/components/base-button/index.vue";
import Expand from "@/icons/common/expand.vue";
import { ref } from "vue";
import { getBrowserName, extensionUrl } from "@/utils/browser";


export default /*#__PURE__*/_defineComponent({
  __name: 'claim-enkrypt-banner',
  setup(__props) {

const isOpen = ref<boolean>(false);

const toggle = () => {
  isOpen.value = !isOpen.value;
};

const action = () => {
  window.open(extensionUrl[browserName], "_blank");
};

const browserName = getBrowserName();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Expand, {
      class: _normalizeClass(["claim-enkrypt-banner__arrow", { open: isOpen.value }]),
      onClick: toggle
    }, null, 8, ["class"]),
    _withDirectives(_createElementVNode("h4", { onClick: toggle }, "I Don't have Polkadot Wallet", 512), [
      [_vShow, !isOpen.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(BaseButton, {
        title: `Get on ${_unref(browserName)} web store`,
        action: action
      }, null, 8, ["title"]),
      _hoisted_5
    ], 512), [
      [_vShow, isOpen.value]
    ])
  ]))
}
}

})